import { getLocalStorage, setLocalStorage } from '@/utils/cookies';
import { atom } from 'recoil';

// COS临时密钥接口定义
interface COSTempKey {
  accessKeyId: string;
  accessKeySecret: string;
  securityToken: string;
  expiration: string;
  region: string;
  bucketName: string;
  baseUrl: string;
}

// COS临时密钥atom，支持持久化存储
export const cosTempKeyAtom = atom<COSTempKey | null>({
  key: 'cosTempKey',
  default: null,
  effects: [
    ({ setSelf, onSet }) => {
      // 从localStorage读取初始值
      const savedValue = getLocalStorage('cosTempKey');
      if (savedValue) {
        try {
          const parsedValue = JSON.parse(savedValue);
          // 检查是否过期
          if (parsedValue && Date.now() < +parsedValue.expiration) {
            setSelf(parsedValue);
          } else {
            // 如果过期，清除存储
            localStorage.removeItem('cosTempKey');
          }
        } catch (error) {
          console.error('解析COS临时密钥失败:', error);
          localStorage.removeItem('cosTempKey');
        }
      }

      // 监听值变化，保存到localStorage
      onSet((newValue) => {
        if (newValue) {
          setLocalStorage('cosTempKey', JSON.stringify(newValue));
        } else {
          setLocalStorage('cosTempKey', '');
        }
      });
    },
  ],
});

// 检查COS临时密钥是否有效的工具函数
export const isCOSKeyValid = (tempKey: COSTempKey | null): boolean => {
  if (!tempKey) return false;

  // 检查是否过期（提前5分钟过期，避免边界情况）
  const currentTime = Date.now();
  const expirationTime = +tempKey.expiration * 1000; // 转换为毫秒
  const bufferTime = 5 * 60 * 1000; // 5分钟缓冲时间

  return currentTime < expirationTime - bufferTime;
};

// 获取COS临时密钥的工具函数
export const getValidCOSKey = (tempKey: COSTempKey | null): COSTempKey | null => {
  if (isCOSKeyValid(tempKey)) {
    return tempKey;
  }
  return null;
};
